<p>recent-searches-list works!</p>
